import { Button, Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Cookies } from "react-cookie";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../css/login.css";
import InputFormat from "../../partials/inputForm";
import {
  getNumberOnString,
  _parsePhoneNumber,
} from "../../partials/validateNumber";
import { Token } from "../../utils/setting";
import ChangeLanguage from "../changeLanguage";
import CountryCode from "../countryCode";
import Dialog from "../dialog";
import Loading from "../loading";
import Logo from "../logoWithText";
import Snackbar from "../snackbar";
import { styles } from "./styles.js";
import packageFile from '../../../package.json'
const cookie = new Cookies();
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        username: "",
        password: "",
        countryCode: this.props.defaultCountryCode || "+84",
        phoneNumber: "",
        activeCode: "",
        newPassword: "",
      },
      valid: {
        username: {
          invalid: false,
          message: "",
        },
      },
      openPicker: false,
      listRoles: [],
      anchorElLanguage: null,
    };
  }
  componentDidMount() {
    cookie.remove(Token);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { user } = this.state;
      user.countryCode = nextProps.defaultCountryCode;
      this.setState({ user: user });
    }
  }
  handleChange = (e) => {
    const { t } = this.props;
    let target = e.target;
    let name = target.name;
    let value =
      name === "username" ? getNumberOnString(target.value) : target.value; // Nếu là username thì chỉ lấy chữ số
    let user = this.state.user;
    user[name] = value;
    if (name === "username" || name === "countryCode") {
      let validNumber = _parsePhoneNumber(user.countryCode, user.username)
        .isValid;
      if (!validNumber) {
        this.setState({
          valid: {
            ...{
              username: {
                invalid: true,
                message: `${user.countryCode + " " + user.username} ${t(
                  "is_invalid_phone"
                )}`,
              },
            },
          },
        });
      } else {
        this.setState({
          valid: {
            ...{
              username: {
                invalid: false,
                message: null,
              },
            },
          },
        });
      }
    }
    this.setState({ user });
  };

  handleCountryCode = (name, value) => {
    let user = this.state.user;
    user[name] = value;
    this.setState({ user });
  };

  handleSubmit = async (event) => {
    let { t } = this.props;
    event.preventDefault();
    this.loading.startLoading();
    this.setState({ openPicker: false });
    let { user } = this.state;
    if (!_parsePhoneNumber(user.countryCode, user.username).isValid)
      this.handleSnackBar(t("Login_phone_number_is_not_valid"), "warning");
    else if (!user.password)
      this.handleSnackBar(t("Login_please_enter_password"), "warning");
    else if (user.password && user.password.length < 6)
      this.handleSnackBar(
        t(
          "Login_the_passord_field_length_must_be_greater_than_or_equal_to_6_characters_long"
        ),
        "warning"
      );
    // else if(user.password.length < 6)
    //     this.handleSnackBar(t("login_enter_your_new_password_that_more_than_6_character"))
    else {
      let res = await this.props.login({ user: user, role: "" });
      if (res.code === 1) {
        // this.setState({ openPicker: true })
        // this.props.history.push({
        //     pathname: '/role',
        //     state: { roles: res.data }
        // })
      } else if (res.error === 1003 || res.error === 1005) {
        this.handleSnackBar(
          t("Login_phone_number_and_password_combination_is_incorrect"),
          "error"
        );
      } else if (res.error === 1122 && res.data.length) {
        if (res.data.length === 1) {
          this.handleSnackBar(
            t(
              "login_you_havent_registered_a_masspa_in_system_so_you_can_not_access_admin_page_lets_click_sign_up"
            ),
            "error"
          );
        } else if (res.data.length === 2) {
          this.handleLoginRole(res.data[1]);
        } else {
          this.setState({ listRoles: res.data });
          this.props.history.push({
            pathname: "/role",
            state: { roles: res.data, user: this.state.user },
          });
          // this.setState({ openPicker: true, listRoles: res.data })
        }
      } else if (res.error === 1187) {
        this.handleSnackBar(t("Login_user_inactive"), "error");
      } else {
        this.handleSnackBar(res.message, "error");
      }
    }
    this.loading.stopLoading();
  };
  handleLoginRole = async (role) => {
    this.handleClose();
    let { t } = this.props;
    this.loading.startLoading();
    let { user } = this.state;
    let res = await this.props.login({ user: user, role: role });
    if (res.code === 1) {
      const data = res.dataUser;
      if (!data.loginTime) this.mDialog.handleDialogOpen();
      else if (
        data.roleId &&
        (data.roleId.role === "ownerSpa" || data.roleId.role === "employeeSpa")
      ) {
        this.props.history.push("/");
      } else if (
        data.roleId &&
        (data.roleId.role === "admin" || data.roleId.role === "employeeAdmin")
      ) {
        this.props.history.push("/");
      }
    } else if (res.error === 1003 || res.error === 1005) {
      this.handleSnackBar(
        t("Login_phone_number_and_password_combination_is_incorrect"),
        "error"
      );
    } else if (res.error === 1122) {
      if (res.data.length === 1) {
        this.handleSnackBar(
          t(
            "login_you_havent_registered_a_masspa_in_system_so_you_can_not_access_admin_page_lets_click_sign_upe"
          ),
          "error"
        );
      } else if (res.data.length === 2) {
        this.handleLoginRole(res.data[1]);
      } else {
        this.setState({ openPicker: true, listRoles: res.data });
      }
    } else if (res.error === 1105) {
      this.handleSnackBar(t("Login_error_access_account"), "error");
    } else if (res.error === 1166) {
      this.handleSnackBar(t("Login_error_package_expired"), "error");
    } else if (res.error === 1175) {
      this.handleSnackBar(
        t("login_employee_executor_can_not_login_admin_page"),
        "error"
      );
    } else if (res.error === 1187) {
      this.handleSnackBar(t("Login_user_inactive"), "error");
    } else if (res.error === 1108) {
      this.handleSnackBar(t("Login_your_account_inactive_or_deleted"), "error");
    } else if (res.error === 1013) {
      this.handleSnackBar(t("Login_your_service_deleted"), "error");
    } else this.handleSnackBar(res.message, "error");

    this.loading.stopLoading();
  };
  handleClose = () => {
    this.setState({ openPicker: false });
  };
  handleSnackBar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };
  handleSetNewPassword = () => {
    this.props.history.push("/profile?password");
  };
  handleActionDialogClose = () => {
    this.props.history.push("/");
  };
  render() {
    const { t, classes } = this.props;
    const { user, valid } = this.state;
    return (
      <div className="login-wrapper">
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <ChangeLanguage />
        <div className="login-container">
          <Dialog
            onRef={(dialog) => (this.mDialog = dialog)}
            disagree={t("login_set_later")}
            agree={t("login_change_password")}
            title={t("login_notice")}
            content={t("login_you_should_change_password_at_first_login")}
            action={this.handleSetNewPassword}
            handleActionDialogClose={this.handleActionDialogClose}
          />
          <div
            className={classes.logo}
            onClick={() => this.props.history.push("/")}
          >
            <Logo />
          </div>
          <form onSubmit={this.handleSubmit} className={classes.container}>
            <Grid container spacing={3} justify="center" alignItems="flex-end">
              <Grid item xs={5} sm={5} md={4}>
                <CountryCode
                  code={user.countryCode}
                  handleCountryCode={this.handleCountryCode}
                // margin="normal"
                />
              </Grid>
              <Grid item xs={7} sm={7} md={8}>
                <InputFormat
                  required
                  label={t("login_phone_number")}
                  placeholder={t("login_phone_number")}
                  className={classes.textField}
                  name={"username"}
                  // margin="normal"
                  value={user.username}
                  onChange={this.handleChange}
                />
              </Grid>
              {/* <Grid item xs={12} className={classes.message}> */}
              {valid.username && valid.username.message ? (
                <div
                  className={classNames(
                    classes.customValid,
                    `${valid.username && valid.username.invalid
                      ? "invalid"
                      : "valid"
                    }-feedback text-left d-block`
                  )}
                >
                  {valid.username ? valid.username.message : ""}
                </div>
              ) : (
                  <div
                    className={classNames(
                      classes.customInValid,
                      `text-left d-block`
                    )}
                  ></div>
                )}
              {/* </Grid> */}
              <Grid item xs={12} sm={12} md={12}>
                <InputFormat
                  label={t("login_password")}
                  className={classes.textField}
                  type="password"
                  name={"password"}
                  required
                  // margin="normal"
                  value={user.password}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classNames("label-bottom", "forget-password")}
              justify="flex-end"
            >
              <Link to="/forgot">
                <Typography variant="body1" className="text-blue">
                  {t("login_forgot_password")}
                </Typography>
              </Link>
            </Grid>
            <Grid container justify="center" alignItems="center">
              <Button
                variant="contained"
                size="large"
                type="submit"
                fullWidth
                color="secondary"
                onClick={this.handleSubmit}
                className={classes.button}
              >
                {t("login_sign_in")}
              </Button>
            </Grid>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ marginTop: 16 }}
            >
              <Link to="/register">
                <p className="text-gray">
                  {t("dont_have_account")}
                  <span className="text-blue">&nbsp;{t("sign_up")}</span>
                </p>
              </Link>
            </Grid>
          </form>
        </div>
        <div className="bottom-version">vAdmin: {packageFile.version}. vAPI: {this.props.versionAPI}</div>
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
  versionAPI: state.setting.version
});

const mapDispatch = (dispatch) => ({
  login: dispatch.user.login,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Login)));
